export const getISOString = (date: Date | string) => {
  try {
    const result = new Date(date).toISOString()
    return result
  } catch {
    return null
  }
}
